import React from "react";
import { base44 } from "@/api/base44Client";
import { clearStoredAccessToken, hasStoredAccessToken } from "@/lib/authToken";

const REF_KEY = "marstick_referral_attribution";
const VISITOR_KEY = "marstick_referral_visitor";

function visitorId() {
  const existing = localStorage.getItem(VISITOR_KEY);
  if (existing) return existing;
  const next = `vis_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  localStorage.setItem(VISITOR_KEY, next);
  return next;
}

export default function ReferralAttributionCapture() {
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref")?.trim().toUpperCase();
    if (!ref || !ref.startsWith("MAR-")) return;

    const payload = { code: ref, captured_at: new Date().toISOString() };
    localStorage.setItem(REF_KEY, JSON.stringify(payload));

    const recordClick = () => {
      base44.entities.ReferralClick.create({
        referral_code: ref,
        landing_url: window.location.href,
        visitor_id: visitorId(),
        clicked_at: payload.captured_at,
      }).catch(() => {});
    };

    const schedule = window.requestIdleCallback
      ? window.requestIdleCallback(recordClick, { timeout: 5000 })
      : window.setTimeout(recordClick, 2500);

    return () => {
      if (window.cancelIdleCallback && typeof schedule === "number") window.cancelIdleCallback(schedule);
      else window.clearTimeout(schedule);
    };
  }, []);

  React.useEffect(() => {
    let cancelled = false;
    const applyReferral = async () => {
      const stored = localStorage.getItem(REF_KEY);
      if (!hasStoredAccessToken()) return;
      const isAuthed = await base44.auth.isAuthenticated();
      if (!isAuthed || cancelled) return;
      const user = await base44.auth.me();
      if (!user?.email) return;
      if (stored) {
        const { code } = JSON.parse(stored);
        if (code) {
          const processedKey = `${REF_KEY}_${user.email}`;
          if (localStorage.getItem(processedKey) !== code) {
            await base44.functions.invoke("captureReferralRegistration", { referral_code: code });
            localStorage.setItem(processedKey, code);
          }
        }
      }
      const todayKey = `marstick_referral_login_${user.email}_${new Date().toISOString().slice(0, 10)}`;
      const countLogin = localStorage.getItem(todayKey) !== "1";
      await base44.functions.invoke("recordReferralActivity", { count_login: countLogin });
      if (countLogin) localStorage.setItem(todayKey, "1");
    };

    const schedule = window.requestIdleCallback
      ? window.requestIdleCallback(() => applyReferral().catch(() => clearStoredAccessToken()), { timeout: 7000 })
      : window.setTimeout(() => applyReferral().catch(() => clearStoredAccessToken()), 3500);

    return () => {
      cancelled = true;
      if (window.cancelIdleCallback && typeof schedule === "number") window.cancelIdleCallback(schedule);
      else window.clearTimeout(schedule);
    };
  }, []);

  return null;
}